import script from "./WhatAreCreditsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatAreCreditsComponent.vue?vue&type=script&setup=true&lang=js"

import "./WhatAreCreditsComponent.vue?vue&type=style&index=0&id=c694f474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c694f474"]])

export default __exports__